import { MIXIN_FORM } from '@/mixins/form/mixinForm'

export const MIXIN_FORM_PTO = {
  props: {
    isParentEntityPage: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [MIXIN_FORM]
}
